<div class="custom-select" [class.small]="small">
  <button
    #button
    type="button"
    class="custom-select-button app-input"
    [disabled]="isDisabled"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
    (click)="toggle($event)"
    (keydown)="onKeydown($event)"
  >
    @if (showIcon) {
      <fa-icon [icon]="icon" class="select-left-icon"></fa-icon>
    }
    <span class="custom-select-label">{{ labelFor(value) }}</span>
    <fa-icon [icon]="faCaretDown" class="select-caret"></fa-icon>
  </button>

  @if (isOpen) {
    <div class="custom-select-dropdown" [class.drop-up]="dropUp">
      @if (showSearch) {
        <div class="custom-select-search">
          <fa-icon [icon]="faFilter" class="search-icon"></fa-icon>
          <input
            #searchInput
            type="text"
            [placeholder]="searchPlaceholder"
            (input)="onSearch($event)"
            (click)="$event.stopPropagation()"
          />
        </div>
      }

      <ul #optionsList class="custom-select-list" (scroll)="onScroll($event)">
        @if (loading && options.length === 0) {
          <li class="custom-select-status">Cargando...</li>
        } @else if (options.length === 0) {
          <li class="custom-select-status">No se encontraron resultados</li>
        }

        @for (opt of options; track $index) {
          <li
            [attr.aria-selected]="opt.value === value"
            [class.focused]="$index === focusedIndex"
            [class.disabled]="opt.disabled"
            [class.selected]="opt.value === value"
          >
            <button
              type="button"
              class="custom-select-option"
              [disabled]="opt.disabled"
              (click)="select(opt)"
              (keydown.enter)="select(opt)"
              (keydown.space)="$event.preventDefault(); select(opt)"
            >
              {{ opt.label }}
              @if (opt.value === value) {
                <fa-icon [icon]="faChartPieSimple" class="selected-icon"></fa-icon>
              }
            </button>
          </li>
        }

        @if (loadingMore) {
          <li class="custom-select-status py-2">
            <div class="loading-spinner small mx-auto"></div>
          </li>
        }
      </ul>
    </div>
  }
</div>
